import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth/auth.service";

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService)

  if(authService.isAuthenticated()) {
    return true;
  }

  router.navigateByUrl('/login');
  return false;
}